(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-ar-body"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.__wmArb) return; root.__wmArb = true;
    var btn = root.querySelector('[data-arb-copy]');
    var note = root.querySelector('[data-arb-copied]');
    if(!btn) return;
    btn.addEventListener('click', function(){
      var url = btn.getAttribute('data-url') || window.location.href;
      function done(){ if(note){ note.hidden = false; setTimeout(function(){ note.hidden = true; }, 2200); } }
      if(navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(url).then(done); }
      else { var t = document.createElement('textarea'); t.value = url; document.body.appendChild(t); t.select(); try{ document.execCommand('copy'); }catch(e){} document.body.removeChild(t); done(); }
    });
  }
  function boot(){ document.querySelectorAll('[data-wm-arb]').forEach(init); }
  if(document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-collection-grid"] && !Shopify.designMode) return;
  try {
    
(function(){

  /* ===================== PORTAL DROPDOWN ===================== */
  (function(){
    var openPanel = null;
    var openTrigger = null;

    function positionPanel(panel, trigger) {
      var r = trigger.getBoundingClientRect();
      panel.style.top  = (r.bottom + window.scrollY + 6) + 'px';
      panel.style.left = r.left + 'px';
    }

    function closeAll() {
      if (openPanel) {
        openPanel.classList.remove('is-open');
        if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
        openPanel = null;
        openTrigger = null;
      }
    }

    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-wm-dd-trigger]');
      if (trigger) {
        e.stopPropagation();
        var panelId = trigger.getAttribute('data-dd-panel');
        var panel = document.getElementById(panelId);
        if (!panel) return;

        // Portal: move to body if not already there
        if (panel.parentElement !== document.body) {
          document.body.appendChild(panel);
        }

        if (openPanel === panel) {
          closeAll();
          return;
        }

        closeAll();
        positionPanel(panel, trigger);
        panel.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        openPanel = panel;
        openTrigger = trigger;
        return;
      }

      // Close if click outside panel
      if (openPanel && !openPanel.contains(e.target)) {
        closeAll();
      }
    }, true);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeAll();
    });

    // Auto-submit on checkbox change
    document.addEventListener('change', function(e) {
      if (e.target.matches('[data-wm-autosubmit]')) {
        var form = document.getElementById(e.target.getAttribute('form'));
        if (form) form.submit();
      }
    });

    // Price apply button
    document.addEventListener('click', function(e) {
      if (e.target.matches('[data-wm-price-apply]')) {
        var panel = e.target.closest('.wm-dd-panel');
        var inputs = panel ? panel.querySelectorAll('[data-wm-price-input]') : [];
        var formId = inputs[0] ? inputs[0].getAttribute('form') : null;
        var form = formId ? document.getElementById(formId) : null;
        if (form) form.submit();
      }
    });

    // Reposition on scroll/resize
    window.addEventListener('scroll', function() {
      if (openPanel && openTrigger) positionPanel(openPanel, openTrigger);
    }, {passive: true});
    window.addEventListener('resize', function() {
      if (openPanel && openTrigger) positionPanel(openPanel, openTrigger);
    }, {passive: true});
  })();

  /* ===================== SORT SELECT ===================== */
  var sortSel = document.querySelector('[data-wm-sort]');
  if (sortSel) {
    sortSel.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ===================== MOBILE DRAWER ===================== */
  var drawerBtn = document.querySelector('[data-wm-open-drawer]');
  var drawer    = document.getElementById('wm-filter-drawer');
  if (drawerBtn && drawer) {
    drawerBtn.addEventListener('click', function() {
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      drawerBtn.setAttribute('aria-expanded', 'true');
    });
    drawer.querySelectorAll('[data-wm-drawer-close]').forEach(function(el) {
      el.addEventListener('click', function() {
        drawer.hidden = true;
        document.body.style.overflow = '';
        if (drawerBtn) drawerBtn.setAttribute('aria-expanded', 'false');
      });
    });
    var applyBtn = drawer.querySelector('[data-wm-drawer-apply]');
    if (applyBtn) {
      applyBtn.addEventListener('click', function() {
        var form = document.getElementById('wm-filter-form-mobile');
        if (form) form.submit();
      });
    }
    drawer.querySelectorAll('[data-wm-group-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var body = btn.nextElementSibling;
        var expanded = btn.getAttribute('aria-expanded') !== 'false';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (body) body.style.display = expanded ? 'none' : '';
      });
    });
  }

  /* ===================== QUICK ADD ===================== */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.wm-clg button[data-wm-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.disabled) return;
    btn.disabled = true;
    var origHTML = btn.innerHTML;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id:parseInt(id,10),quantity:1}]})
    }).then(function(r){return r.json();})
      .then(function(){
        btn.classList.add('is-added');
        setTimeout(function(){btn.disabled=false;btn.classList.remove('is-added');btn.innerHTML=origHTML;},1500);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function(){btn.disabled=false;btn.innerHTML=origHTML;});
  });

  /* ===================== FAVOURITE ===================== */
  document.addEventListener('click', function(e){
    var fav = e.target.closest('.wm-clg [data-wm-fav]');
    if (fav) fav.classList.toggle('is-saved');
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-gift-concierge"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.__wmGc) return; root.__wmGc = true;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-gc-item]'));
    if(!items.length) return;

    function selected(group){
      var btn = root.querySelector('[data-gc-group="'+group+'"] .wm-gc__pill.is-active');
      return btn || null;
    }
    function tagOf(btn){ return btn ? (btn.getAttribute('data-tag')||'').trim() : ''; }

    function matches(item, useRecipient, useOccasion){
      var tags = '|'+(item.getAttribute('data-tags')||'')+'|';
      var price = parseInt(item.getAttribute('data-price')||'0',10);
      var b = selected('budget');
      var min = b ? parseInt(b.getAttribute('data-min')||'0',10) : 0;
      var max = b ? parseInt(b.getAttribute('data-max')||'99999999',10) : 99999999;
      if(price < min || price > max) return false;
      if(useRecipient){ var rt = tagOf(selected('recipient')); if(rt && tags.indexOf('|'+rt+'|') === -1) return false; }
      if(useOccasion){ var ot = tagOf(selected('occasion')); if(ot && tags.indexOf('|'+ot+'|') === -1) return false; }
      return true;
    }

    function update(){
      // progressive fallback: all three -> drop occasion -> drop recipient -> budget only -> first three
      var passes = [[true,true],[true,false],[false,true],[false,false]];
      var shown = [];
      for(var p=0; p<passes.length && shown.length<3; p++){
        for(var i=0; i<items.length && shown.length<3; i++){
          if(shown.indexOf(items[i])===-1 && matches(items[i], passes[p][0], passes[p][1])) shown.push(items[i]);
        }
      }
      if(!shown.length) shown = items.slice(0,3);
      items.forEach(function(it){ it.hidden = shown.indexOf(it)===-1; });
    }

    root.addEventListener('click', function(e){
      var pill = e.target.closest('.wm-gc__pill'); if(!pill) return;
      var group = pill.closest('[data-gc-group]');
      group.querySelectorAll('.wm-gc__pill').forEach(function(b){ b.classList.remove('is-active'); b.setAttribute('aria-pressed','false'); });
      pill.classList.add('is-active'); pill.setAttribute('aria-pressed','true');
      update();
    });
    update();
  }
  function boot(){ document.querySelectorAll('[data-wm-gc]').forEach(init); }
  if(document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);

  // quick add
  if(!window.__wmGcAdd){
    window.__wmGcAdd = true;
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-wm-gc] button[data-wm-add]'); if(!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id'); if(!id || btn.disabled) return;
      btn.disabled = true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
        .then(function(r){return r.json();})
        .then(function(){btn.classList.add('is-added');setTimeout(function(){btn.disabled=false;btn.classList.remove('is-added');},1500);})
        .catch(function(){btn.disabled=false;});
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-header"]) return;
  try {
    
(function(){
  function $(s,r){return (r||document).querySelector(s);}
  function $all(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}
  function formatMoney(cents,format){
    if(typeof cents==='string'){cents=cents.replace('.','');}
    var fmt=format||'${{amount}}';
    function thousands(num,precision,t,d){precision=precision==null?2:precision;t=t||',';d=d||'.';if(isNaN(num)||num==null){return '0';}num=(num/100).toFixed(precision);var p=num.split('.'),dollars=p[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1'+t),c=p[1]?d+p[1]:'';return dollars+c;}
    var m=fmt.match(/\{\{\s*(\w+)\s*\}\}/);var key=m?m[1]:'amount';var val;
    switch(key){case 'amount_no_decimals':val=thousands(cents,0);break;case 'amount_with_comma_separator':val=thousands(cents,2,'.',',');break;case 'amount_no_decimals_with_comma_separator':val=thousands(cents,0,'.',',');break;default:val=thousands(cents,2);}
    return fmt.replace(/\{\{\s*\w+\s*\}\}/,val);
  }
  var root=$('#wm-cart');
  if(!root) return;
  var MONEY=root.getAttribute('data-money-format')||'${{amount}}';
  var THRESHOLD=parseInt(root.getAttribute('data-threshold')||'0',10);
  function lock(){document.body.classList.add('wm-lock');}
  function unlock(){if(!document.querySelector('.wm-cart.is-open,.wm-mobile.is-open,.wm-search.is-open'))document.body.classList.remove('wm-lock');}
  function openEl(el){el.classList.add('is-open');el.setAttribute('aria-hidden','false');lock();}
  function closeEl(el){el.classList.remove('is-open');el.setAttribute('aria-hidden','true');unlock();}
  var cartEl=root,mobileEl=$('[data-wm-mobile]');
  function openCart(){renderCart();openEl(cartEl);}
  function openMobile(){openEl(mobileEl);}
  function lineHTML(it){
    var img=it.featured_image&&it.featured_image.url?it.featured_image.url:(it.image||'');
    if(img){img=img+(img.indexOf('?')>-1?'&':'?')+'width=160';}
    var v=(it.variant_title&&it.variant_title.toLowerCase()!=='default title')?'<div class="wm-li__v">'+it.variant_title+'</div>':'';
    return '<div class="wm-li" data-key="'+it.key+'"><img class="wm-li__img" src="'+img+'" alt="" loading="lazy"><div><a class="wm-li__t" href="'+it.url+'">'+(it.product_title||it.title)+'</a>'+v+'<div class="wm-li__ctrl"><button type="button" data-wm-dec aria-label="Decrease">&minus;</button><span class="wm-li__qty">'+it.quantity+'</span><button type="button" data-wm-inc aria-label="Increase">+</button></div></div><div class="wm-li__right"><span class="wm-li__price">'+formatMoney(it.final_line_price,MONEY)+'</span><button type="button" class="wm-li__rm" data-wm-rm>Remove</button></div></div>';
  }
  function ship(total){
    var msg=$('[data-wm-ship-msg]'),fill=$('[data-wm-ship-fill]'),wrap=$('[data-wm-ship]');
    if(!THRESHOLD||THRESHOLD<=0){if(wrap)wrap.style.display='none';return;}
    if(wrap)wrap.style.display='';
    var pct=Math.min(100,Math.round(total/THRESHOLD*100));
    if(fill)fill.style.width=pct+'%';
    if(total>=THRESHOLD){msg.innerHTML='<b>Complimentary delivery unlocked.</b>';}
    else{msg.innerHTML="You're <b>"+formatMoney(THRESHOLD-total,MONEY)+"</b> away from complimentary delivery.";}
  }
  function paint(cart){
    var items=$('[data-wm-items]'),empty=$('[data-wm-empty]'),foot=$('[data-wm-foot]'),ship_=$('[data-wm-ship]');
    $all('[data-wm-count]').forEach(function(n){n.textContent=cart.item_count;});
    var bubble=$('[data-wm-bubble]');
    if(bubble){bubble.textContent=cart.item_count;bubble.classList.toggle('is-empty',cart.item_count===0);}
    if(cart.item_count===0){items.innerHTML='';items.style.display='none';empty.hidden=false;foot.style.display='none';if(ship_)ship_.style.display='none';}
    else{items.style.display='';empty.hidden=true;foot.style.display='';items.innerHTML=cart.items.map(lineHTML).join('');$('[data-wm-subtotal]').textContent=formatMoney(cart.total_price,MONEY);ship(cart.total_price);}
  }
  function renderCart(open){
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){paint(c);if(open)openEl(cartEl);}).catch(function(){});
  }
  function change(key,qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(paint).catch(function(){});
  }
  document.addEventListener('click',function(e){
    var t=e.target;
    if(t.closest('[data-wm-open-cart]')){e.preventDefault();openCart();}
    else if(t.closest('[data-wm-open-search]')){e.preventDefault();closeEl(mobileEl);window.location.href='/search';}
    else if(t.closest('[data-wm-open-mobile]')){e.preventDefault();openMobile();}
    else if(t.closest('[data-wm-close]')){e.preventDefault();closeEl(cartEl);}
    else if(t.closest('[data-wm-close-mobile]')){e.preventDefault();closeEl(mobileEl);}
    else{var li=t.closest('.wm-li');if(li){var key=li.getAttribute('data-key');var qty=parseInt(li.querySelector('.wm-li__qty').textContent,10)||1;if(t.closest('[data-wm-inc]')){change(key,qty+1);}else if(t.closest('[data-wm-dec]')){change(key,Math.max(0,qty-1));}else if(t.closest('[data-wm-rm]')){change(key,0);}}}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeEl(cartEl);closeEl(mobileEl);}});
  var hdr=$('[data-wm-header]');
  if(hdr){var onScroll=function(){hdr.classList.toggle('is-scrolled',window.scrollY>4);};window.addEventListener('scroll',onScroll,{passive:true});onScroll();}
  function setStickTop(){
    var hg=document.getElementById('header-group');if(!hg)return;
    var mySection=hg.querySelector('.wm-header-section');
    if(!mySection){var d=hg.querySelector('[data-wm-header]');mySection=d?(d.closest('.shopify-section')||d.parentElement):null;}
    var before=0,c=hg.firstElementChild;
    while(c&&c!==mySection){before+=c.offsetHeight;c=c.nextElementSibling;}
    hg.style.setProperty('--wm-stick-top',(-before)+'px');
  }
  setStickTop();
  window.addEventListener('resize',setStickTop,{passive:true});
  window.addEventListener('load',setStickTop);
  setTimeout(setStickTop,400);
  if(!window.__wmCartHooked){
    window.__wmCartHooked=true;
    var _fetch=window.fetch;
    window.fetch=function(){var args=arguments;var url=args[0]&&args[0].url?args[0].url:args[0];var p=_fetch.apply(this,args);try{if(typeof url==='string'&&/\/cart\/add(\.js)?(\?|$)/.test(url)){p.then(function(res){if(res&&res.ok){setTimeout(function(){renderCart(true);},60);}});}}catch(err){}return p;};
    var _open=XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open=function(m,u){this.__wmUrl=u;return _open.apply(this,arguments);};
    var _send=XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send=function(){var x=this;if(typeof x.__wmUrl==='string'&&/\/cart\/add/.test(x.__wmUrl)){x.addEventListener('load',function(){if(x.status>=200&&x.status<300){setTimeout(function(){renderCart(true);},60);}});}return _send.apply(this,arguments);};
  }
  renderCart(false);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-jr-pairing"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  function init(root){
    if(root.__wmJrpV2) return;
    root.__wmJrpV2 = true;

    var items = Array.from(root.querySelectorAll('[data-jrp-item]'));
    if(!items.length) return;

    var cycle = 0;
    var currentTag = '';
    var currentPick = null;

    function getMatching(tag){
      if(!tag) return items;
      var m = items.filter(function(it){
        return ('|' + (it.dataset.tags||'') + '|').indexOf('|'+tag+'|') !== -1;
      });
      return m.length ? m : items;
    }

    function show(tag, resetCycle){
      if(resetCycle) cycle = 0;
      var pool = getMatching(tag);
      var pick = pool[cycle % pool.length];

      if(pick === currentPick) return;
      currentPick = pick;

      items.forEach(function(it){
        it.hidden = true;
        it.setAttribute('aria-hidden','true');
        it.classList.remove('entering');
      });

      pick.hidden = false;
      pick.setAttribute('aria-hidden','false');
      // trigger reflow for animation
      void pick.offsetWidth;
      pick.classList.add('entering');
    }

    function activeTag(){
      var b = root.querySelector('.wm-jrp__pill.is-active');
      return b ? (b.dataset.tag||'').trim() : '';
    }

    root.addEventListener('click', function(e){
      var pill = e.target.closest('.wm-jrp__pill');
      if(!pill) return;

      if(pill.classList.contains('is-active')){
        // same pill → cycle through
        cycle++;
        show(activeTag(), false);
      } else {
        root.querySelectorAll('.wm-jrp__pill').forEach(function(b){
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed','false');
          b.setAttribute('aria-selected','false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-pressed','true');
        pill.setAttribute('aria-selected','true');
        show(pill.dataset.tag || '', true);
      }
    });

    currentTag = activeTag();
    show(currentTag, true);
  }

  function boot(){
    document.querySelectorAll('[data-wm-jrp]').forEach(init);
  }

  if(document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function(e){
    var el = e.target.querySelector('[data-wm-jrp]');
    if(el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-prd-estate"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.__wmPres) return; root.__wmPres = true;
    var track = root.querySelector('[data-pres-track]'); if(!track) return;
    var prev = root.querySelector('[data-pres-prev]'), next = root.querySelector('[data-pres-next]');
    function step(){ var c = track.querySelector('.wm-pcard'); var g = parseFloat(getComputedStyle(track).columnGap)||16; return c ? Math.round(c.getBoundingClientRect().width+g) : Math.round(track.clientWidth*0.8); }
    function update(){ if(!prev||!next) return; var max = track.scrollWidth - track.clientWidth - 2; prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft >= max; }
    if(prev) prev.addEventListener('click', function(){ track.scrollBy({left:-step(), behavior:'smooth'}); });
    if(next) next.addEventListener('click', function(){ track.scrollBy({left:step(), behavior:'smooth'}); });
    track.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update, {passive:true});
    update();
  }
  function boot(){ document.querySelectorAll('[data-wm-pres]').forEach(init); }
  if(document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);

  if(!window.__wmPresAdd){
    window.__wmPresAdd = true;
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-wm-pres] button[data-wm-add]'); if(!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id'); if(!id || btn.disabled) return;
      btn.disabled = true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
        .then(function(r){return r.json();})
        .then(function(){btn.classList.add('is-added');setTimeout(function(){btn.disabled=false;btn.classList.remove('is-added');},1500);})
        .catch(function(){btn.disabled=false;});
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-rail"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.wm-rail-section').forEach(function(section){
    var track = section.querySelector('[data-wm-track]');
    var prev  = section.querySelector('[data-wm-prev]');
    var next  = section.querySelector('[data-wm-next]');
    if(!track) return;
    function cardWidth(){
      var c = track.querySelector('.wm-pcard');
      return c ? c.offsetWidth + parseInt(getComputedStyle(track).gap||0) : 300;
    }
    function update(){
      if(!prev||!next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    if(prev) prev.addEventListener('click',function(){track.scrollBy({left:-cardWidth(),behavior:'smooth'});});
    if(next) next.addEventListener('click',function(){track.scrollBy({left: cardWidth(),behavior:'smooth'});});
    track.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update,{passive:true});
    update();
    /* favourite + quick-add */
    section.addEventListener('click',function(e){
      var fav = e.target.closest('[data-wm-fav]');
      if(fav){fav.classList.toggle('is-saved');return;}
      var btn = e.target.closest('button[data-wm-add]');
      if(btn){
        e.preventDefault();
        var id = btn.getAttribute('data-variant-id');
        if(!id||btn.disabled) return;
        btn.disabled=true;
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
          .then(function(r){return r.json();})
          .then(function(){btn.classList.add('is-added');setTimeout(function(){btn.disabled=false;btn.classList.remove('is-added');},1500);})
          .catch(function(){btn.disabled=false;});
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-regions"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.__wmReg) return; root.__wmReg=true;
    var track=root.querySelector('[data-wm-track]');
    if(!track) return;
    var prev=root.querySelector('[data-wm-prev]'), next=root.querySelector('[data-wm-next]');
    function step(){
      var tile=track.querySelector('.wm-reg__tile');
      var gap=parseFloat(getComputedStyle(track).columnGap)||16;
      return tile?Math.round(tile.getBoundingClientRect().width+gap):Math.round(track.clientWidth*0.8);
    }
    function update(){
      if(!prev||!next) return;
      var max=track.scrollWidth-track.clientWidth-2;
      prev.disabled=track.scrollLeft<=2;
      next.disabled=track.scrollLeft>=max;
    }
    if(prev) prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
    if(next) next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
    track.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update,{passive:true});
    update();
  }
  function boot(){document.querySelectorAll('[data-wm-reg]').forEach(init);}
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-rg-wines"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.__wmPres) return; root.__wmPres = true;
    var track = root.querySelector('[data-pres-track]'); if(!track) return;
    var prev = root.querySelector('[data-pres-prev]'), next = root.querySelector('[data-pres-next]');
    function step(){ var c = track.querySelector('.wm-pcard'); var g = parseFloat(getComputedStyle(track).columnGap)||16; return c ? Math.round(c.getBoundingClientRect().width+g) : Math.round(track.clientWidth*0.8); }
    function update(){ if(!prev||!next) return; var max = track.scrollWidth - track.clientWidth - 2; prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft >= max; }
    if(prev) prev.addEventListener('click', function(){ track.scrollBy({left:-step(), behavior:'smooth'}); });
    if(next) next.addEventListener('click', function(){ track.scrollBy({left:step(), behavior:'smooth'}); });
    track.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update, {passive:true});
    update();
  }
  function boot(){ document.querySelectorAll('[data-wm-pres]').forEach(init); }
  if(document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);

  if(!window.__wmPresAdd){
    window.__wmPresAdd = true;
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-wm-pres] button[data-wm-add]'); if(!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id'); if(!id || btn.disabled) return;
      btn.disabled = true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
        .then(function(r){return r.json();})
        .then(function(){btn.classList.add('is-added');setTimeout(function(){btn.disabled=false;btn.classList.remove('is-added');},1500);})
        .catch(function(){btn.disabled=false;});
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-search-results"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-wm-srch]');
  if(!root) return;
  var statusEl = root.querySelector('[data-wm-status]');
  /* quick-add (single-variant products) */
  root.addEventListener('click', function(e){
    var btn = e.target.closest('button[data-wm-add]');
    if(!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if(!id || btn.dataset.busy) return;
    btn.dataset.busy = '1';
    fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id:parseInt(id,10),quantity:1}]})
    }).then(function(r){return r.json();})
      .then(function(item){ btn.classList.add('is-added'); if(statusEl){ statusEl.textContent = ((item && item.product_title) || 'Item') + ' added to cart'; } setTimeout(function(){ delete btn.dataset.busy; btn.classList.remove('is-added'); },1500); document.dispatchEvent(new CustomEvent('cart:refresh')); })
      .catch(function(){ delete btn.dataset.busy; });
  });
  /* favourite toggle (visual) */
  root.addEventListener('click', function(e){
    var fav = e.target.closest('[data-wm-fav]');
    if(fav) fav.setAttribute('aria-pressed', fav.classList.toggle('is-saved'));
  });

  /* ---- client-side pager over the fully-rendered, description-filtered card set ----
     The whole kept set is in the DOM already (server rendered), so page count, per-page
     size and total are identical for every capitalisation of the query. Buttons show/hide
     slices only (no navigation), so nothing re-queries Shopify or shifts the result set. */
  (function(){
    var grid = root.querySelector('[data-wm-grid]');
    var pager = root.querySelector('[data-wm-pager]');
    if(!grid || !pager) return;
    var per = parseInt(grid.getAttribute('data-per-page'), 10) || 24;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.wm-pcard'));
    var total = cards.length;
    /* sync the browser tab / meta title to the true filtered count (Shopify's default title uses the raw match count) */
    try{ var qy=(new URLSearchParams(location.search).get('q')||'').trim(); if(qy){ document.title='Search: '+total+' result'+(total===1?'':'s')+' found for “'+qy+'” – The Wine Monk'; } }catch(e){}
    var pages = Math.ceil(total / per);
    if(pages <= 1){ pager.hidden = true; return; }
    var cur = 1;
    function pill(label, page, opts){
      opts = opts || {};
      if(opts.current) return '<span class="wm-srch__pag-num is-current" aria-current="page">'+label+'</span>';
      return '<button type="button" class="wm-srch__pag-num'+(opts.arrow?' wm-srch__pag-arrow':'')+'" data-page="'+page+'"'+(opts.label?' aria-label="'+opts.label+'"':'')+'>'+label+'</button>';
    }
    function build(){
      var h = '';
      if(cur > 1) h += pill('←', cur-1, {arrow:true, label:'Previous page'});
      h += '<ul class="wm-srch__pag-nums">';
      for(var p=1; p<=pages; p++){ h += '<li>'+pill(p, p, {current: p===cur})+'</li>'; }
      h += '</ul>';
      if(cur < pages) h += pill('→', cur+1, {arrow:true, label:'Next page'});
      pager.innerHTML = h;
    }
    function show(p, scroll){
      cur = Math.min(Math.max(1, p), pages);
      var start = (cur-1)*per, end = start+per;
      for(var i=0;i<cards.length;i++){ cards[i].style.display = (i>=start && i<end) ? '' : 'none'; }
      build();
      if(statusEl){ statusEl.textContent = 'Showing '+(start+1)+'–'+Math.min(end,total)+' of '+total; }
      if(scroll){ var a = root.querySelector('.wm-srch__in'); if(a){ window.scrollTo({top: a.getBoundingClientRect().top + window.pageYOffset - 90, behavior:'smooth'}); } }
    }
    pager.addEventListener('click', function(e){
      var b = e.target.closest('button[data-page]');
      if(!b) return;
      show(parseInt(b.getAttribute('data-page'), 10), true);
    });
    pager.hidden = false;
    show(1, false);
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-search"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-wms]'); if(!root||root.__wms) return; root.__wms=true;
  var input=root.querySelector('[data-wms-input]');
  var results=root.querySelector('[data-wms-results]');
  var discover=root.querySelector('[data-wms-discover]');
  var dk=root.querySelector('[data-wms-dk]');
  var suggs=Array.prototype.slice.call(root.querySelectorAll('[data-wms-sugg]'));
  var ctrl=null,timer=null,isOpen=false;
  function lock(on){document.documentElement.style.overflow=on?'hidden':'';}
  function doOpen(){root.classList.add('is-open');root.setAttribute('aria-hidden','false');lock(true);isOpen=true;filterSuggs(input.value);setTimeout(function(){input.focus();},60);}
  function doClose(){root.classList.remove('is-open');root.setAttribute('aria-hidden','true');lock(false);isOpen=false;}
  function filterSuggs(q){
    q=(q||'').trim().toLowerCase();var counts={},shown=0;
    suggs.forEach(function(a){
      var k=a.getAttribute('data-kind')||'x';counts[k]=counts[k]||0;
      var hit=!q||((a.getAttribute('data-name')||'').indexOf(q)>-1);
      var ok=hit&&counts[k]<4;if(ok)counts[k]++;
      a.style.display=ok?'':'none';if(ok)shown++;
    });
    if(discover)discover.style.display=shown?'':'none';
    if(dk)dk.style.display=q?'none':'';
  }
  function fetchResults(q){
    if(ctrl)ctrl.abort();ctrl=new AbortController();
    results.classList.add('is-loading');
    var rootPath=(window.Shopify&&Shopify.routes&&Shopify.routes.root)?Shopify.routes.root:'/';
    var url=rootPath+'search/suggest?q='+encodeURIComponent(q)+'&section_id=wm-search-results&resources[type]=product,collection&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    fetch(url,{signal:ctrl.signal}).then(function(r){return r.text();}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var p=doc.querySelector('[data-wms-payload]');
      results.innerHTML=p?p.innerHTML:'';
      results.classList.remove('is-loading');
    }).catch(function(e){if(e.name!=='AbortError'){results.classList.remove('is-loading');}});
  }
  input.addEventListener('input',function(){
    var q=input.value;filterSuggs(q);clearTimeout(timer);
    if(!q.trim()){if(ctrl)ctrl.abort();results.innerHTML='';return;}
    timer=setTimeout(function(){fetchResults(q.trim());},200);
  });
  root.addEventListener('click',function(e){if(e.target.closest('[data-wms-close]'))doClose();});
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&isOpen){doClose();return;}
    var el=e.target,tag=(el.tagName||'').toLowerCase();
    var typing=tag==='input'||tag==='textarea'||el.isContentEditable;
    if(!isOpen&&(((e.metaKey||e.ctrlKey)&&(e.key==='k'||e.key==='K'))||(e.key==='/'&&!typing))){e.preventDefault();doOpen();}
  });
  document.addEventListener('click',function(e){
    var trg=e.target.closest('[data-wm-open-search],[data-wms-open]');
    if(!trg||root.contains(trg))return;
    e.preventDefault();e.stopPropagation();
    var mob=document.querySelector('[data-wm-mobile]');
    if(mob&&mob.classList.contains('is-open')){mob.classList.remove('is-open');mob.setAttribute('aria-hidden','true');document.body.classList.remove('wm-lock');}
    doOpen();
  },true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-you-may-also-like"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function(){
  var LN = Math.log(2.5); /* price proximity hits 0 at 2.5x away from the anchor (log scale) */
  var W_REGION = 1.0, W_PRODUCER = 0.6, W_PRICE = 1.0;
  var REGION_HANDLES = ["piedmont","tuscany","friuli","champagne","nahe","bordeaux","burgundy","chablis","emilia-romagna","veneto","campania","coonawarra","puglia","rioja","rhone","sicily","trentino","wachau","alsace","clare-valley"];

  function handleize(s){ return String(s||'').toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,''); }
  function broadRegion(tags){ for(var i=0;i<(tags||[]).length;i++){ var h=handleize(tags[i]); if(REGION_HANDLES.indexOf(h)>=0) return h; } return ''; }
  function gj(u){ return fetch(u,{headers:{'Accept':'application/json'}}).then(function(r){ return r.ok?r.json():null; }).catch(function(){ return null; }); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'})[c]; }); }
  function titleCase(h){ return String(h||'').replace(/-/g,' ').replace(/\b\w/g,function(m){ return m.toUpperCase(); }); }

  /* Build a card from Collection-JSON data, matching the server card markup. Used only to
     augment the rail with price-relevant wines that Liquid's 50-product cap could not reach
     (e.g. high-priced anchors, since region collections are sorted price-ascending). */
  function buildCardHTML(o){
    var p = o.json, v = o.variant;
    var country = ''; (p.tags||[]).forEach(function(t){ if(/^(italy|france|spain|germany|austria|australia|usa|portugal)$/i.test(t)) country = t; });
    var region = o.regionHandle ? titleCase(o.regionHandle) : '';
    var regionLabel = region + (country ? (region ? ', ' : '') + country : '');
    var img = (p.images && p.images[0] && (p.images[0].src || p.images[0])) || p.featured_image || '';
    if(img && String(img).indexOf('http') === 0){ img = img + (String(img).indexOf('?') >= 0 ? '&' : '?') + 'width=600'; }
    var pt = (p.type||'').toLowerCase();
    var btla = '#62141f', btlb = '#3c0c15';
    if(pt.indexOf('white') >= 0){ btla = '#d8c98a'; btlb = '#b9a45a'; } else if(pt.indexOf('ros') >= 0){ btla = '#e8a9a0'; btlb = '#cf7d72'; }
    var media = img
      ? '<img class="wm-rel__img" src="'+esc(img)+'" loading="lazy" alt="'+esc(p.title)+'">'
      : '<svg class="wm-rel__bottle" viewBox="0 0 80 232" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="'+esc(p.title)+'"><defs><linearGradient id="wmrelj-'+p.id+'" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="'+btla+'"/><stop offset="0.5" stop-color="'+btlb+'"/><stop offset="1" stop-color="'+btla+'"/></linearGradient></defs><path d="M33 18 q0 -5 4 -5 h6 q4 0 4 5 v38 c0 6 14 9 14 30 v114 q0 9 -9 9 H28 q-9 0 -9 -9 V86 c0 -21 14 -24 14 -30 z" fill="url(#wmrelj-'+p.id+')"/><path d="M33 18 q0 -5 4 -5 h6 q4 0 4 5 v22 H33 z" fill="#4A0E18"/><rect x="24" y="118" width="32" height="66" rx="3" fill="#f6f1e7"/></svg>';
    return '<article class="wm-rel__card" data-pid="'+p.id+'" data-type="'+esc(pt)+'" data-price="'+o.price+'" data-region="'+(o.reg?1:0)+'" data-producer="'+(o.prod?1:0)+'" data-avail="'+(o.avail?1:0)+'">'
      + '<a class="wm-rel__link" href="/products/'+esc(p.handle)+'"><div class="wm-rel__media">'+media+'</div>'
      + '<div class="wm-rel__info">'+(regionLabel?'<span class="wm-rel__region">'+esc(regionLabel)+'</span>':'')
      + '<h3 class="wm-rel__name">'+esc(p.title)+'</h3>'+(p.vendor?'<span class="wm-rel__producer">'+esc(p.vendor)+'</span>':'')+'</div></a>'
      + '<div class="wm-rel__foot"><div class="wm-rel__price">S$'+Math.round(o.price/100)+'</div>'
      + '<button type="button" class="wm-rel__qadd" data-vid="'+((v&&v.id)||'')+'" aria-label="Add '+esc(p.title)+' to cart"'+(o.avail?'':' disabled')+'><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg></button></div></article>';
  }

  /* Price-aware ranking. Anchor = current product price. Region & price are co-primary,
     producer is a booster, neither is mandatory. Hard band [anchor*low, anchor*high] with a
     capped progressive widen (never unbounded, so no extreme price jumps); in-stock preferred.
     The server pool (Liquid, 50-cap, price-ascending) covers most anchors; when it lacks enough
     in-band candidates (high-priced wines), we fetch the full region JSON to fill the gap. */
  function rankRail(root){
    var rail = root.querySelector('.wm-rel__rail'); if(!rail) return;
    var anchor  = parseFloat(root.getAttribute('data-anchor'))    || 0;
    var bandLow = parseFloat(root.getAttribute('data-band-low'))  || 0.6;
    var bandHigh= parseFloat(root.getAttribute('data-band-high')) || 1.5;
    var limit   = Math.min(parseInt(root.getAttribute('data-limit'),10) || 8, 12);
    var selfId  = parseInt(root.getAttribute('data-product'),10) || 0;
    var regionHandle = (root.getAttribute('data-region-handle')||'').trim();
    var curVendor = (root.getAttribute('data-vendor')||'').trim().toLowerCase();

    var serverCards = Array.prototype.slice.call(rail.querySelectorAll('.wm-rel__card'));
    if(!serverCards.length) return;

    function prox(price){ if(!anchor || !price) return 0; return Math.max(0, 1 - Math.abs(Math.log(price/anchor)) / LN); }
    var byId = {}, pool = [];
    serverCards.forEach(function(c){
      var id = parseInt(c.getAttribute('data-pid'),10) || 0;
      var o = { id:id, el:c, price:parseFloat(c.getAttribute('data-price'))||0, reg:c.getAttribute('data-region')==='1', prod:c.getAttribute('data-producer')==='1', avail:c.getAttribute('data-avail')!=='0' };
      if(id) byId[id] = o;
      pool.push(o);
    });

    function bands(){ return [[bandLow,bandHigh],[bandLow*0.66,bandHigh*1.34],[bandLow*0.4,bandHigh*2]]; }
    function inBand(list, lo, hi){
      var f = anchor ? list.filter(function(o){ return o.price >= anchor*lo && o.price <= anchor*hi; }) : list.slice();
      f.sort(function(a,b){ return (b.score - a.score) || (prox(b.price) - prox(a.price)) || (a.price - b.price); });
      return f;
    }
    function select(list){ var bs = bands(), out = []; for(var i=0;i<bs.length;i++){ out = inBand(list, bs[i][0], bs[i][1]); if(out.length >= limit) break; } return out; }

    function inPrimaryBand(o){ return anchor && o.avail && o.price >= anchor*bandLow && o.price <= anchor*bandHigh; }

    function finish(){
      pool.forEach(function(o){ o.score = W_REGION*(o.reg?1:0) + W_PRODUCER*(o.prod?1:0) + W_PRICE*prox(o.price); });
      var chosen = select(pool.filter(function(o){ return o.avail; }));
      if(chosen.length < limit){ select(pool.filter(function(o){ return !o.avail; })).forEach(function(o){ if(chosen.indexOf(o) < 0) chosen.push(o); }); }
      chosen = chosen.slice(0, limit);
      serverCards.forEach(function(c){ if(c.parentNode) c.parentNode.removeChild(c); });
      chosen.forEach(function(o){
        var el = o.el;
        if(!el){ var tmp = document.createElement('div'); tmp.innerHTML = buildCardHTML(o); el = tmp.firstElementChild; }
        if(el) rail.appendChild(el);
      });
    }

    /* Only reach for the network when the server pool can't fill the primary band. */
    if(pool.filter(inPrimaryBand).length >= limit || !regionHandle){ finish(); return; }
    gj('/collections/'+regionHandle+'/products.json?limit=250').then(function(data){
      (data && data.products || []).forEach(function(p){
        if(p.id === selfId || byId[p.id]) return;
        var vs = p.variants || [], v = null;
        for(var i=0;i<vs.length;i++){ if(vs[i].available){ v = vs[i]; break; } }
        if(!v) v = vs[0]; if(!v) return;
        var price = Math.round(parseFloat(v.price)*100) || 0;
        var rh = broadRegion(p.tags||[]);
        var o = { id:p.id, el:null, json:p, variant:v, price:price, regionHandle:rh,
                  reg:(!!rh && rh===regionHandle), prod:(curVendor!=='' && (p.vendor||'').toLowerCase()===curVendor),
                  avail:vs.some(function(x){ return x.available; }) };
        byId[p.id] = o; pool.push(o);
      });
      finish();
    });
  }

  document.querySelectorAll('[data-wm-rel]').forEach(function(root){
    var id = root.id.replace('wm-rel-','');
    var rail = root.querySelector('#wm-rail-'+id);

    rankRail(root);

    root.querySelectorAll('.wm-rel__nav [data-dir]').forEach(function(b){
      b.addEventListener('click', function(){
        if(!rail) return;
        var card = rail.querySelector('.wm-rel__card');
        var step = card ? card.offsetWidth + 22 : 300;
        rail.scrollBy({ left: step * parseInt(b.getAttribute('data-dir'),10), behavior: 'smooth' });
      });
    });

    if(rail){
      rail.addEventListener('click', function(e){
        var btn = e.target.closest('.wm-rel__qadd');
        if(!btn || btn.disabled) return;
        e.preventDefault();
        var vid = btn.getAttribute('data-vid');
        if(!vid) return;
        btn.classList.add('is-loading');
        fetch('/cart/add.js',{ method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ id: parseInt(vid,10), quantity: 1 }) })
        .then(function(r){ return r.json(); })
        .then(function(){ document.dispatchEvent(new CustomEvent('cart:refresh')); })
        .catch(function(){})
        .finally(function(){ btn.classList.remove('is-loading'); });
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
